import { useEffect, useState } from 'react'
import { VscVersions } from 'react-icons/vsc'
import { deleteButton, deleteVariant, getButtonById, removeAllVariants } from '../../../API/Buttons/Buttons'
import { ButtonMessage, SingleButton } from '../../../API/Buttons/models'
import { Button, Card } from 'react-bootstrap'
import { EditVariantModal } from './components/EditVariantModal'
import { Title } from '../../../../Templates/Title'
import { NewVariantModal } from './components/NewVariantModal'
import Swal from 'sweetalert2'
import toast from 'react-hot-toast'
import { TbTrash } from 'react-icons/tb'
import { getStaticIconCategory, getStaticIconName } from './utils/utils'
import { BiArrowBack, BiTrashAlt } from 'react-icons/bi'
import { FaRegCopy } from 'react-icons/fa'
import { useStaticButtonsIcons } from './hooks/useStaticButtonsIcons'
import { EditButtonModal } from './components/EditButtonModal'
import { BulkUploadVariantsModal } from './components/BulkUploadVariantsModal'
import { AdminUser } from '../../../API/AdminInfo/models'
import cookies from 'js-cookie'
interface Props {
    adminInfo: AdminUser | null
    selectedButton: SingleButton | null
    setShowButtonInformation: (show: boolean) => void
    setSelectedButton: (button: SingleButton | null) => void
}



export const Variants = ({ adminInfo, selectedButton, setShowButtonInformation, setSelectedButton }: Props) => {

    const { iconsHandler } = useStaticButtonsIcons()
    const [button, setButton] = useState<SingleButton | null>(null)

    // Modals
    const [showEditVariantModal, setShowEditVariantModal] = useState(false)
    const [selectedVariant, setSelectedVariant] = useState<ButtonMessage | null>(null)
    const [showNewVariantModal, setShowNewVariantModal] = useState(false)
    const [showEditButtonModal, setShowEditButtonModal] = useState(false)
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false)

    const fetchButton = async () => {
        const res = await getButtonById(selectedButton?.id ?? '')
        if (res) {
            setButton(res)
        }
    }

    const handleDeleteVariant = async (variant: ButtonMessage) => {
        if (button?.Messages.length === 1) {
            Swal.fire({
                text: 'El botón debe tener al menos una variante.',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#ef4444',
                cancelButtonColor: '#b6bac3',
            })

            return
        }

        Swal.fire({
            title: '¿Estás seguro?',
            text: `Eliminar variante "${variant.text.slice(0, 20)}${variant.text.length > 20 ? '...' : ''}"`,
            // icon: 'warning',
            confirmButtonText: "Si, eliminar",
            showCancelButton: true,

            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#b6bac3',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const res = await deleteVariant({ messageId: variant.id })
                if (res === 'done') {
                    fetchButton()
                    toast.success('Variante eliminada')
                }

            }
        })
    }


    const handleDeleteButton = async (button: SingleButton | null) => {
        if (!button) return
        Swal.fire({
            title: '¿Estás seguro?',
            html: `Eliminar botón "${button.name}". <br/> <br/> <span class="text-danger">Se eliminarán todas las variantes asociadas.</span>`,
            confirmButtonText: "Si, eliminar",
            showCancelButton: true,
            confirmButtonColor: '#ef4444',

            cancelButtonColor: '#b6bac3',

        }).then(async (result) => {
            if (result.isConfirmed) {
                const res = await deleteButton({ buttonId: button.id })
                if (res === 'done') {
                    // handleFetchButtons();
                    // setSelectedButton(null);
                    toast.success('Botón eliminado')
                    setShowButtonInformation(false)
                }
            }
        })

    }

    const handleRemoveAllVariants = async (button: SingleButton | null) => {
        if (!button) return
        
        Swal.fire({
            title: '¿Estás seguro?',
            html: `Eliminar todas las variantes del botón "${button.name}". <br/> <br/> <span class="text-danger">Esta acción no se puede deshacer.</span>`,
            confirmButtonText: "Si, eliminar todas",
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#b6bac3',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const res = await removeAllVariants({ buttonId: button.id })
                if (res && res.success) {
                    toast.success(res.msg || 'Todas las variantes eliminadas')
                    fetchButton()
                } else {
                    toast.error(res?.msg || 'Error al eliminar las variantes')
                }
            }
        })
    }


    useEffect(() => {
        if (showEditVariantModal === false && showNewVariantModal === false && showEditButtonModal === false && showBulkUploadModal === false) {
            fetchButton()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedButton?.id, showEditVariantModal, showNewVariantModal, showEditButtonModal, showBulkUploadModal])


    const dmpr = cookies.get('dmpr') === '__dm__'
    const subTitle = 'Al clickear un botón, copiará una de las variantes al azar entre las disponibles.'

    return (
        <>

            <EditVariantModal
                show={showEditVariantModal}
                onHide={() => setShowEditVariantModal(false)}
                variant={selectedVariant ?? null}
                buttonName={button?.name ?? ''}
                adminInfo={adminInfo}
                selectedButton={selectedButton}
            />

            <NewVariantModal
                show={showNewVariantModal}
                onHide={() => setShowNewVariantModal(false)}
                buttonName={button?.name ?? ''}
                adminInfo={adminInfo}
                buttonId={button?.id ?? ''}
                selectedButton={selectedButton}
            />


            {showEditButtonModal &&
                <EditButtonModal
                    show={showEditButtonModal}
                    onHide={() => setShowEditButtonModal(false)}
                    selectedButton={selectedButton}
                />
            }

            <BulkUploadVariantsModal
                show={showBulkUploadModal}
                onHide={() => setShowBulkUploadModal(false)}
                selectedButton={selectedButton}
                adminInfo={adminInfo}
            />

            <div className='d-flex justify-content-between align-items-end mb-3'>
                <Button variant='dark' className='d-flex gap-2 align-items-center text-primaryy' onClick={() => {
                    setShowButtonInformation(false)
                    setSelectedButton(null)
                }}>
                    <BiArrowBack size={20} /> Atrás
                </Button>
            </div>


            <div className='mb-1 d-flex justify-content-between align-items-center mt-5 '>
                <Title title={`${getStaticIconName(button)}`} icon={<FaRegCopy size={30} />} subtitle={`${getStaticIconCategory(button)}`} />
            </div>



            {(dmpr || button?.category !== 'static_button') &&
                <Card style={{ width: 'fit-content' }}>
                    <Card.Body>
                        <div className='d-flex gap-1 align-items-center'>
                            {/* <div>
                            <button
                                key={'button-variants'}
                                className={`btn btn-sm  my-1 m-1 gap-2 d-flex align-items-center bg-secondary text-white py-1`}
                            >
                                {iconsHandler({ button: button?.name ?? '' })}   {getStaticIconName(button)}
                            </button>
                        </div> */}
                            <div>
                                {(dmpr || button?.category !== 'static_button') &&
                                    <Button variant='' className="btn btn-sm text-white" onClick={() => {
                                        handleDeleteButton(button ?? null)
                                    }}>
                                        <BiTrashAlt className='text-danger' size={20} />
                                    </Button>
                                }
                            </div>
                            <div>
                                {button?.category !== 'static_button' &&
                                    <Button variant='' className="btn btn-sm text-white text-xs" onClick={() => {
                                        setShowEditButtonModal(true)
                                    }}>
                                        Editar
                                    </Button>
                                }
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            }

            <div className='mb-1 d-flex justify-content-between align-items-center mt-5'>
                <Title title='Variantes' icon={<VscVersions size={30} />} subtitle={subTitle} />
            </div>

            <Card>

                <Card.Body>
                    <div className='mb-4 d-flex gap-1 align-items-center'>
                        <span className='text-secondary text-xs'>
                            Variantes para el Botón {getStaticIconName(button)}
                        </span>
                    </div>


                    <div className='d-flex flex-column w-100 gap-1'>
                        {button?.Messages?.map((message) => (
                            <Card key={message.id} className='py-0 bg-dark bg-opacity-25 border-primaryy'>
                                <Card.Body className='d-flex justify-content-between align-items-start align-items-md-center py-2'>
                                    <div key={message.id}>{message.text.slice(0, 200)} {message.text.length > 200 && '...'}</div>
                                    <div className='d-flex gap-1 align-items-center'>
                                        <Button variant='' onClick={() => {
                                            setSelectedVariant(message)
                                            handleDeleteVariant(message)
                                        }}>
                                            <TbTrash className='text-danger' size={20} />
                                        </Button>
                                        <Button variant='dark py-1' onClick={() => {
                                            setSelectedVariant(message)
                                            setShowEditVariantModal(true)
                                        }}>
                                            Editar
                                        </Button>

                                    </div>
                                </Card.Body>
                            </Card>

                        ))}
                    </div>
                    <div className='d-flex justify-content-end gap-2 align-items-end mt-3'>
                       {button?.Messages && button?.Messages?.length > 0 && <Button variant='outline-danger' disabled={button?.Messages?.length === 0} onClick={() => {
                            handleRemoveAllVariants(button)
                        }}>
                            Eliminar Todas
                        </Button>}

                        <Button variant='outline-primary' onClick={() => {
                            setShowBulkUploadModal(true)
                        }}>
                            Carga Masiva
                        </Button>

                        <Button variant='primary' onClick={() => {
                            setShowNewVariantModal(true)
                        }}>
                            Crear Variante
                        </Button>

                    </div>
                </Card.Body>
            </Card >

        </>

    )
}

